<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    label?: string | null
  }>(),
  { label: null }
)

const emit = defineEmits(['update:modelValue'])

const localValue = ref(props.modelValue)

watch(localValue, (newValue) => {
  emit('update:modelValue', newValue)
})

watch(() => props.modelValue, (newValue) => {
  localValue.value = newValue
})
</script>

<template>
  <div>
    <label class="flex cursor-pointer items-center">
      <input v-model="localValue" class="sr-only" type="checkbox">

      <div
        class="relative h-6 w-11 rounded-full transition duration-200 ease-linear"
        :class="{'bg-green-500': localValue, 'bg-gray-300': !localValue}"
      >
        <div
          class="
            absolute left-1 top-1 size-4 rounded-full bg-white shadow transition duration-200 ease-linear
          "
          :class="{'translate-x-5': localValue, 'translate-x-0': !localValue}"
        />
      </div>

      <span v-if="label" class="ml-3">
        {{ label }}
      </span>
    </label>
  </div>
</template>
